import type { ITableReference } from './genericQuery';
import { GenericQuery } from './genericQuery';
import { handleUnknownError } from '../handleError';

export class RedshiftQuery extends GenericQuery {
  protected parseTables(): ITableReference[] {
    const tables: ITableReference[] = [];
    const regex = /(?:([^\s]+)\.)?(?:"([^"]+)"|([^\s.]+))/g;
    const result = this.sanitizedQuery.match(regex);
    this.tokens = result || [];

    this.tokens.forEach((token, index) => {
      if (token.toLowerCase() === 'from' || token.toLowerCase() === 'join') {
        let nextToken = '';
        let nextNextToken = '';
        try {
          nextToken = this.tokens[index + 1] ?? '';
          nextNextToken = this.tokens[index + 2] ?? '';
        } catch (e) {
          handleUnknownError(e);
          /* do not fail if there is no next token */
        }
        if (nextToken && !nextToken.startsWith('(')) {
          const tableReference = this.parseTableReference(nextToken, nextNextToken);

          if (tableReference && tableReference.table !== '') {
            // if object does not exist in array, add it
            if (
              !tables.some(
                (t) => t.table.toLowerCase() === tableReference.table.toLowerCase() && t.schema?.toLowerCase() === tableReference.schema?.toLowerCase(),
              )
            ) {
              tables.push(tableReference);
            }
          }
        }
      }
    });

    return tables;
  }
}
